import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function FastBalancesSetupView
 * @returns {React.Component}
 * @exported true
 * @description This is the view that is shown when we click the "Fast Balances" button on the login page. It shows above the login inputs and is only shown for captures.
 */
export default function FastBalancesSetupView(props) {
  return(
    // remove hide class to show for captures
    <div className="fast-balance-setup-view flex-height flex-container flex-vertical space-around">
      <div className="flex-container flex-horizontal align-center set-height header-text-container">
        <h3 className="flex-width">Set up Fast Balances</h3>
        <SVGAsset className="set-width clickable" id="XIcon" />
      </div>
      <div className="text-container description-container flex-height">
        <p className="description-text">Quickly and securely see your account balances without logging in.</p>
      </div>
      <div className="text-container steps-container flex-height">
        <p className="description-text">To set up:</p>
        <ol className="fast-balance-steps">
          <li>Log in</li>
          <li>Go to Menu &gt; Settings &gt; Fast Balances</li>
          <li>Turn Fast Balances on</li>
          <li>Select your accounts</li>
        </ol>
      </div>
    </div>
  );
}